import * as React from 'react';
import { SVGProps } from 'react';

const IconInfoCircleSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm1.203-8.27a.86.86 0 1 1-1.72 0 .86.86 0 0 1 1.72 0ZM4.802 4.284a.1.1 0 0 1 .097-.076h1.346a.673.673 0 0 1 .662.798v.001L6.218 8.34a.157.157 0 0 0 .251.15l.024-.019a.201.201 0 0 0 .072-.12l.107-.57a.1.1 0 0 1 .098-.081h1.167a.1.1 0 0 1 .098.118l-.147.781a1.548 1.548 0 0 1-.555.924l-.024.02a1.503 1.503 0 0 1-2.415-1.453v-.002l.536-2.532h-.819a.1.1 0 0 1-.097-.125l.287-1.146Z"
    />
  </svg>
);
export default IconInfoCircleSizeXs;
